var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('top-header',{on:{"title-search":_vm.toChildMsg}})],1),_vm._v(" "),_c('el-main',[_c('app-main',{attrs:{"titleSearch":_vm.titleSearch}})],1),_vm._v(" "),_c('el-footer',[_c('app-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b563180","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 